// extracted by mini-css-extract-plugin
var _1 = "BreadcrumbsCollapsed-moduleBreadcrumbsCollapsed__zzHlS";
var _2 = "BreadcrumbsCollapsed-modulelist__CyCQX";
export { _1 as "BreadcrumbsCollapsed", _2 as "list" }
